const manifest = {
  key: 'noodles-exclusive',
  name: 'Noodles Exclusive',
  description: 'Full-screen animated flavor showcase intro (first visit only) ahead of code entry.',
  thumbnail: '/assets/images/templates/noodles-exclusive-thumbnail.png',
  // When false: hidden from the dashboard's Template tab and excluded entirely from the production build.
  is_deploy: true
};

export default manifest;
